import {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

class MessageEvent extends Component {

  constructor(props) {
    super(props);
    const {interventionId, ticket} = props;
    if (typeof EventSource !== "undefined") {
      this.eventSource = new EventSource(`/api/notifications/${interventionId}?ticket=${ticket}`);
    } else {
      // IE
      this.eventSource = {
        addEventListener : function(){
        },
        close : function(){
        }
      }
    }
  }

  componentDidMount(){
    const {interventionId} = this.props;
    this.eventSource.addEventListener(`MESSAGE_${interventionId}`, e=> {
      this.props.dispatchNewMessage({message:JSON.parse(e.data)});
    });

    this.eventSource.addEventListener(`READ_${interventionId}`, e=> {
      this.props.dispatchReadMessage(JSON.parse(e.data));
    });

    // this.eventSource.addEventListener(`HEARTBEAT`, e=> {
    //   console.log('Heartbeat');
    //   //this.props.dispatchReadMessage(JSON.parse(e.data));
    // });

    this.eventSource.onerror = event=>{
      console.log('Error with EventSource ' + event);
      console.dir(event.target);
      console.log('Closing event source');
      this.eventSource.close();
    };
  }

  componentWillUnmount(){
    // We need to close the EventSource otherwise we will reach the open connection limit (6 on chrome)
    this.eventSource.close();
  }

  render() {

    return null;
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  dispatchNewMessage: (message) => dispatch({type: 'SAVE.NEW_MESSAGE_RECEIVED.REQUEST', ...message}),
  dispatchReadMessage: (readAcknowledge) => dispatch({type: 'SAVE.MESSAGE_READ.REQUEST', ...readAcknowledge}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)(injectIntl(MessageEvent))
